// removed by extract-text-webpack-plugin
module.exports = {"title":"pQxhHu0","listContainer":"_2vx2JAg"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/index.css
// module chunks = client.sitechrome